import React from "react";
import { DappContextProvider } from "../../contexts/MintContext";

export function NetworkErrorMessage(): React.ReactElement {
  const { networkError, dismissNetworkError } = React.useContext(DappContextProvider);

  return (
    <div className="connection-message" role="alert">
      {networkError}
      <button
        type="button"
        className="connection-message close-button"
        data-dismiss="alert"
        aria-label="Close"
        onClick={dismissNetworkError}
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  );
}
